import {
  Bescheidstatus,
  bescheidstatusToString
} from '../../../api/models/Status/Bescheidstatus';
import { Bearbeitungsstand } from '../../../api/models/Status/Bearbeitungsstand';
import { Badge } from '@efast_public/fjd-component-library';
import type { BadgeProps } from '@efast_public/fjd-component-library';

export interface BescheidstatusBadgeProps {
  readonly bescheidstatus: Bescheidstatus;
  readonly bearbeitungsstand?: Bearbeitungsstand;
  readonly fjdBadgeSize: BadgeProps['size'];
  readonly badgeLabel?: string;
}

export default function BescheidstatusBadge(props: BescheidstatusBadgeProps) {
  let variant: BadgeProps['variant'];
  let iconBefore: BadgeProps['iconBefore'];

  switch (props.bescheidstatus) {
    case Bescheidstatus.NOCHNICHTBESCHIEDEN:
      variant = 'neutral';
      break;
    case Bescheidstatus.POSITIV:
      iconBefore = 'checkmark';
      if (props.bearbeitungsstand === Bearbeitungsstand.ABGESCHLOSSEN) {
        variant = 'neutral';
      } else {
        variant = 'success';
      }
      break;
    case Bescheidstatus.NEGATIV:
      iconBefore = 'error-filled';
      if (props.bearbeitungsstand === Bearbeitungsstand.ABGESCHLOSSEN) {
        variant = 'neutral';
      } else {
        variant = 'error';
      }
      break;
    default:
      return null;
  }

  return (
    <Badge
      variant={variant}
      label={
        props.badgeLabel
          ? props.badgeLabel
          : bescheidstatusToString(props.bescheidstatus)
      }
      size={props.fjdBadgeSize}
      iconBefore={iconBefore}
    />
  );
}
